import { useSyncExternalStore } from "react";

const TOKEN_KEY = "tokenSAE";
const SESSION_COOKIE = "saeSessionToken";
const AUTH_EVENT = "sae-auth-change";

export function getAuthToken() {
  const persistentToken = localStorage.getItem(TOKEN_KEY);
  if (persistentToken) return persistentToken;
  const cookie = document.cookie.split("; ").find((item) => item.startsWith(`${SESSION_COOKIE}=`));
  return cookie ? decodeURIComponent(cookie.slice(SESSION_COOKIE.length + 1)) : null;
}

function notifyTabs() {
  localStorage.setItem("saeAuthChange", `${Date.now()}-${Math.random()}`);
  window.dispatchEvent(new Event(AUTH_EVENT));
}

function writeSessionCookie(value, expired = false) {
  document.cookie = `${SESSION_COOKIE}=${encodeURIComponent(value)}; Path=/; SameSite=Lax${
    window.location.protocol === "https:" ? "; Secure" : ""
  }${expired ? "; Max-Age=0" : ""}`;
}

export function saveAuthToken(token, remember) {
  localStorage.removeItem(TOKEN_KEY);
  writeSessionCookie("", true);
  if (remember) localStorage.setItem(TOKEN_KEY, token);
  else writeSessionCookie(token);
  localStorage.setItem("saeRememberLogin", String(remember));
  notifyTabs();
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
  writeSessionCookie("", true);
  notifyTabs();
}

export function getBrowserId() {
  let id = localStorage.getItem("saeBrowserId");
  if (!id || !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id)) {
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    id = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    localStorage.setItem("saeBrowserId", id);
  }
  return id;
}

function subscribe(callback) {
  window.addEventListener("storage", callback);
  window.addEventListener(AUTH_EVENT, callback);
  return () => {
    window.removeEventListener("storage", callback);
    window.removeEventListener(AUTH_EVENT, callback);
  };
}

export function useAuthToken() {
  return useSyncExternalStore(subscribe, getAuthToken);
}
